<div class="pt-3 pl-md-4" *ngIf="categoryNotFound">
  <h2>Category not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingCategory">
  <h2>Loading Category...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewCategory ? 'create' : 'edit' }}
    event categories.
  </h2>
</div>

<div *ngIf="(serverError === null) && !categoryNotFound && !loadingExistingCategory && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/events/setup/categories" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for categories -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-danger btn-sm ml-2"
              *ngIf="!isNewCategory"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleDelete()">
        {{ loadingDelete ? 'Removing...' : 'Remove' }}
      </button>
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 pb-5">
      <h2>
        {{ isNewCategory ? 'New Event Category' : 'Edit Event Category' }}
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">
                    Name
                  </label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="category.name"
                         (ngModelChange)="handleNameChange(); unsavedChanges = true;">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="urlHashInput">
                    URL hash
                  </label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">#</span>
                    </div>
                    <input id="urlHashInput" type="text" name="url_hash"
                           class="form-control"
                           [(ngModel)]="category.url_hash"
                           (ngModelChange)="handleUrlHashChange(); unsavedChanges = true;">
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                This is placed in the Climber App URL when the event type category is selected. The URL hash may only contain letters, digits, and dashes.
              </small>
              <div class="form-text text-danger">{{ errors.url_hash }}</div>
            </div>

            <div class="form-group">
              <label class="mb-1">Event Types In This Category</label>
              <span *ngIf="loadingEventTypes" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingEventTypes">
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        type="button"
                        *ngIf="!allEventTypesAreSelected()"
                        (click)="setAllEventTypesSelected(); unsavedChanges = true;">
                  Select All
                </button>
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        type="button"
                        *ngIf="allEventTypesAreSelected()"
                        (click)="setNoEventTypesSelected(); unsavedChanges = true;">
                  Deselect All
                </button>
                  <div class="form-check" *ngFor="let eventType of getFilteredEventTypes()">
                  <input class="form-check-input" type="checkbox" id="etCheckbox{{ eventType.id }}"
                         [checked]="eventTypeSelected(eventType)"
                         (click)="toggleEventType(eventType); unsavedChanges = true;">
                  <label class="form-check-label" for="etCheckbox{{ eventType.id }}">
                    {{ eventType.name }}
                    <span *ngIf="eventType.status === EventTypeStatus.draft">(Draft)</span>
                    <span *ngIf="eventType.status === EventTypeStatus.retired">(Retired)</span>
                  </label>
                </div>
              </ng-container>
            </div>

          </div>
        </div>

        <!-- Allows inputs to submit when enter is pressed -->
        <button type="submit" class="d-none">Hidden submit button</button>
      </form>
    </div>
  </div>
</div>
